/**
 * Registry of all delivery (Statsig) keys used in Supabase edge functions.
 * Add or remove keys here — this file is the single source of truth and the
 * intended diff surface for key changes during code review.
 */

/** Feature flags (Statsig gates) checked in edge functions. Single source of truth for gate names. */
export const FeatureFlags = {} as const;

export const MetricEvents = {
  claimVerificationTimingEmbed: "claim.verification.timing.embed",
  claimVerificationTimingSearch: "claim.verification.timing.search",
  claimVerificationTimingRerank: "claim.verification.timing.rerank",
  claimVerificationTimingJudge: "claim.verification.timing.judge",
  claimVerificationTimingTotal: "claim.verification.timing.total",
  claimVerificationCompleted: "claim.verification.completed",
  claimVerificationRefused: "claim.verification.refused",
  claimVerificationInsufficientEvidence: "claim.verification.insufficient_evidence",
  claimVerificationIrrelevantSources: "claim.verification.irrelevant_sources",
  claimExtractionCompleted: "claim.extraction.completed",
  claimExplanationWordBudgetExceeded: "claim.explanation.word_budget_exceeded",
  expertInsightsInsightPublished: "expert_insights.insight.published",
  infraLlmRetry: "infra.llm.retry",
  infraEmbeddingRetry: "infra.embedding.retry",
  infraReconcilerListFailed: "infra.reconciler.list_failed",
  infraLlmOutputTokens: "infra.llm.output_tokens",
  platformPageViewed: "platform.page.viewed",
  platformClaimSubmitted: "platform.claim.submitted",
  platformVerificationViewed: "platform.verification.viewed",
  platformVerificationShared: "platform.verification.shared",
  platformCoverageRequested: "platform.coverage.requested",
  corpusFieldAnnotated: "corpus.field.annotated",
} as const;

/** Statsig dynamic configs read in edge functions. Single source of truth for config names. */
export const DynamicConfigs = {
  batchJobTuning: "batch_job_tuning",
} as const;
